import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { X } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "admin") navigate("/admin");
      else if (u.role === "driver") navigate("/driver");
      else navigate("/passenger");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "#2B2B2B" }}>
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 fade-in">
        <div className="flex items-start justify-between mb-2">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Inicia sesión</h1>
            <p className="text-slate-500 text-sm mt-2">Accede a tu portal de cliente, conductor o administrador</p>
          </div>
          <Link to="/" className="text-slate-400 hover:text-slate-700" data-testid="close-login-btn"><X size={22} /></Link>
        </div>

        <div className="border-t border-slate-100 my-6" />

        <form onSubmit={submit} data-testid="login-form">
          <div className="mb-4">
            <label className="label">Email</label>
            <input
              type="email"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              placeholder="tucorreo@ejemplo.com"
            />
          </div>
          <div className="mb-5">
            <label className="label">Contraseña</label>
            <input
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="mb-4 p-3 rounded-xl bg-red-50 text-red-700 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit-btn">
            {loading ? "Iniciando..." : "Iniciar sesión"}
          </button>

          <div className="text-center mt-6 text-sm text-slate-600">
            ¿No tienes cuenta?{" "}
            <Link to="/register" className="font-bold" style={{ color: "#F5B700" }} data-testid="goto-register-link">
              Regístrate
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
